import { DeviceType, SupportedDeviceType } from '../types';

export function parseSupportedDeviceTypes(configuredValues: string[] = []): SupportedDeviceType[] {
  // Normalize device type labels from backend payloads to frontend enum values.
  // We currently fall back to both device families because the product assumes
  // Healthdot and viQtor are available together, but we still preserve backend
  // parsing so HCO-specific device-type gating can be re-enabled later.
  const values = Array.isArray(configuredValues) ? configuredValues : [];

  const supportedDeviceTypes = new Set<SupportedDeviceType>();
  values.forEach((value) => {
    const normalized = value.toLowerCase();
    if (normalized.includes('viqtor')) {
      supportedDeviceTypes.add(DeviceType.ViQtor);
      return;
    }

    if (normalized.includes('healthdot') || normalized.includes('hd5')) {
      supportedDeviceTypes.add(DeviceType.Healthdot);
    }
  });

  if (supportedDeviceTypes.size === 0) {
    return [DeviceType.Healthdot, DeviceType.ViQtor];
  }

  return Array.from(supportedDeviceTypes);
}

export function resolveRegexWithFallback(candidate: unknown, fallback: string): string {
  if (typeof candidate !== 'string' || candidate.trim().length === 0) {
    return fallback;
  }

  try {
    // Validate regex eagerly; if backend sends malformed pattern, keep fallback.
    RegExp(candidate);
    return candidate;
  } catch {
    return fallback;
  }
}
